<template>
  <div class="text-left">
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="text-h4">
          <p class="subtitle-1">Select input options </p>
        </v-col>
      </v-row>

      <v-row>
        <SelectInput
          multiple
          :items="myFruits"
          class="text-left"
          item-name="name"
          item-value="value"
          required
          v-model="selectedFruits"/>
      </v-row>
    </v-container>
  </div>

</template>

<script>
import SelectInput from "@/components/SelectInput";

export default {
  components: {SelectInput},
  data: () => ({
    myFruits: [{text:'Apple', value: 1},{text:'Apricots', value: 2},{text:'Avocado', value: 3},{text:'Bananas', value: 4}],
    fruits: [
      'Apples',
      'Apricots',
      'Avocado',
      'Bananas',
      'Blueberries',
      'Blackberries',
      'Boysenberries',
      'Bread fruit',
      'Cantaloupes (cantalope)',
      'Cherries',
      'Cranberries',
      'Cucumbers',
      'Currants',
      'Dates',
      'Eggplant',
      'Figs',
      'Grapes',
      'Grapefruit',
      'Guava',
      'Honeydew melons',
      'Huckleberries',
      'Kiwis',
      'Kumquat',
      'Lemons',
      'Limes',
      'Mangos',
      'Mulberries',
      'Muskmelon',
      'Nectarines',
      'Olives',
      'Oranges',
      'Papaya',
      'Peaches',
      'Pears',
      'Persimmon',
      'Pineapple',
      'Plums',
      'Pomegranate',
      'Raspberries',
      'Rose Apple',
      'Starfruit',
      'Strawberries',
      'Tangerines',
      'Tomatoes',
      'Watermelons',
      'Zucchini',
    ],
    selectedFruits: [],
  }),
  computed: {
    likesAllFruit () {
      return this.selectedFruits.length === this.fruits.length
    },
    likesSomeFruit () {
      return this.selectedFruits.length > 0 && !this.likesAllFruit
    },
    icon () {
      if (this.likesAllFruit) return 'mdi-close-box'
      if (this.likesSomeFruit) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  methods: {
    toggle () {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.selectedFruits = []
        } else {
          this.selectedFruits = this.fruits.slice()
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
